module.exports = __webpack_public_path__ + "img/draw2_img8.5586a462.png";